import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectionComplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 320,
	height: 240,
	viewBox: "0 0 320 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 80,
			height: 80,
			transform: "matrix(-1 0 0 1 160 160)",
			fill: "#58D7B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160 160L160 240L240 240C240 195.824 204.19 160 160 160Z",
			fill: "#58D7B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-6.35574e-07 6.35574e-07L-7.62939e-06 80L80 80C80 35.8237 44.1897 4.49876e-06 -6.35574e-07 6.35574e-07Z",
			fill: "#58D7B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M-6.35574e-07 80L-7.62939e-06 160L80 160C80 115.824 44.1897 80 -6.35574e-07 80Z",
			fill: "#58D7B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240 160L240 240L320 240C320 195.824 284.19 160 240 160Z",
			fill: "#B39AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240 80L240 160L320 160C320 115.824 284.19 80 240 80Z",
			fill: "#B39AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 160L80 240L0 240C-3.86201e-06 195.824 35.8103 160 80 160Z",
			fill: "#171718"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M320 6.35574e-07L320 80L240 80C240 35.8237 275.81 4.49876e-06 320 6.35574e-07Z",
			fill: "#5599FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80,
			width: 160,
			height: 160,
			rx: 80,
			fill: "#FCE5A5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_1573_14966)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M196.161 40.8282C194.599 39.2662 192.066 39.2663 190.504 40.8283L143.334 87.9988L129.496 74.1609C127.934 72.5988 125.401 72.5988 123.839 74.1608L112.829 85.1704C111.266 86.7325 111.266 89.2652 112.829 90.8273L140.505 118.504C142.067 120.066 144.6 120.066 146.162 118.504L207.171 57.4948C208.734 55.9327 208.734 53.3999 207.171 51.8378L196.161 40.8282Z",
				fill: "#2F965D"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M142.627 88.7059L143.334 89.413L144.041 88.7059L191.211 41.5354C192.383 40.3639 194.282 40.3639 195.454 41.5354L206.464 52.545C207.636 53.7165 207.636 55.6161 206.464 56.7877L145.455 117.797C144.283 118.969 142.384 118.969 141.212 117.797L113.536 90.1202C112.364 88.9486 112.364 87.0491 113.536 85.8775L124.546 74.8679C125.718 73.6964 127.617 73.6964 128.789 74.868L142.627 88.7059Z",
				stroke: "#171718",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_1573_14966",
			x: 111.657,
			y: 39.6572,
			width: 97.6861,
			height: 81.0186,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 1,
					dy: 1
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0 0.0941176 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1573_14966"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1573_14966",
					result: "shape"
				})
			]
		}) })
	]
});
export { SvgConnectionComplete as ReactComponent };
